module.exports = __webpack_public_path__ + "static/img/Anasuya_Sengupta.af7aa7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/keynotes/avatar/Anasuya_Sengupta.jpg
// module id = 611
// module chunks = 1